const defaultWidth = 20;
const defaultHeight = 20;

export const EditEmailIcon = ({ width = defaultWidth, height = defaultHeight, color = '#6A737D' }: SvgProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.553 10.7197C13.8459 10.4268 14.3208 10.4268 14.6137 10.7197L17.1137 13.2197C17.4066 13.5126 17.4066 13.9874 17.1137 14.2803L14.6137 16.7803C14.3208 17.0732 13.8459 17.0732 13.553 16.7803C13.2601 16.4874 13.2601 16.0126 13.553 15.7197L14.7727 14.5L3.25 14.5C2.83579 14.5 2.5 14.1642 2.5 13.75C2.5 13.3358 2.83579 13 3.25 13L14.7727 13L13.553 11.7803C13.2601 11.4874 13.2601 11.0126 13.553 10.7197Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.447 3.21967C6.1541 2.92678 5.67923 2.92678 5.38634 3.21967L2.88634 5.71967C2.59344 6.01256 2.59344 6.48744 2.88634 6.78033L5.38634 9.28033C5.67923 9.57322 6.1541 9.57322 6.447 9.28033C6.73989 8.98744 6.73989 8.51256 6.447 8.21967L5.22733 7L16.75 7C17.1642 7 17.5 6.66421 17.5 6.25C17.5 5.83579 17.1642 5.5 16.75 5.5L5.22733 5.5L6.447 4.28033C6.73989 3.98744 6.73989 3.51256 6.447 3.21967Z"
        fill={color}
      />
    </svg>
  );
};

EditEmailIcon.displayName = 'EditEmailIcon';
